export * from './callout';

// Popover extension has been moved to @examdojo/core/tiptap-popover
